import { Component, Input, OnInit } from '@angular/core';
import { NgbModal, NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { CandidateService } from '../../../../services/recruitments/candidates.service';
import { CandidateFormComponent } from './form/form.component';
@Component({
  selector: 'app-shared-candidates',
  templateUrl: './candidates.component.html',
  styleUrl: './candidates.component.scss'
})
export class CandidatesComponent {
  @Input() candidates: any[] = [];
  @Input() isExternalCompany: boolean = true;
  filteredCandidates: any[] = [];
  searchText: string = '';
  page = 1;
  pageSize = 10;
  totalItems = 0;

  constructor(
    private modalService: NgbModal,
    private candidateService: CandidateService,
    private config: NgbPaginationConfig
  ) {
    // customize default values of paginations used by this component tree
    this.config.pageSize = this.pageSize;
    this.config.maxSize = 5;
  }

  ngOnChanges(): void {
    this.applyFilter();
  }

  openModal(candidate?: any): void {
    const modalRef = this.modalService.open(CandidateFormComponent);
    modalRef.componentInstance.candidate = candidate ? candidate : {};
    modalRef.result.then((result) => {
      if (result) {
        if (result.id) {
          this.updateCandidate(result);
        } else {
          this.addCandidate(result);
        }
      }
    }, (reason) => { });
  }

  addCandidate(position: any): void {
    this.candidateService.addCandidate(position)
      .subscribe(newPosition => {
        this.candidates.push(newPosition);
        this.applyFilter();
      });
  }

  updateCandidate(position: any): void {
    this.candidateService.updateCandidate(position)
      .subscribe(updatedCandidate => {
        const index = this.candidates.findIndex(s => s.id === updatedCandidate.id);
        if (index !== -1) {
          this.candidates[index] = updatedCandidate;
          this.applyFilter();
        }
      });
  }

  deleteCandidate(candidate: any): void {
    this.candidates = this.candidates.filter(s => s !== candidate);
    this.candidateService.deleteCandidate(candidate.id).subscribe();
    this.applyFilter();
  }

  applyFilter(): void {
    this.filteredCandidates = this.candidates.filter(candidate =>
      candidate.name.toLowerCase().includes(this.searchText.toLowerCase())
    );
    this.totalItems = this.filteredCandidates.length;
    this.page = 1;
  }

  pageChange(page: number): void {
    this.page = page;
  }

  clearSearch(): void {
    this.searchText = '';
    this.applyFilter();
  }
}
